export type CollectionResource = "tasks" | "clients" | "cases";

/** AppSync Events channel for creation pings visible to unrestricted list viewers. */
export const collectionEventChannel = (resource: CollectionResource): string =>
  `collections/${resource}`;
